import { Outlet } from "react-router-dom";

const AccommodationPage = () => {
    return (
        <Outlet />
    );
};

export default AccommodationPage;
